import { Typography, useTheme } from '@mui/material';
import snakeCase from 'lodash/snakeCase';
import replace from 'lodash/replace';
import round from 'lodash/round';
import React, { useEffect, useState } from 'react';
import { moneyPrint } from '@pv/common/utils';
import { getEventsStyles } from '../../../../events/styles';
import {
  EventStatusColors,
  PVGray,
  PVHoverNavy,
  PVNavy,
} from '@pv/common/colors';
import { EventStatus } from '../../../../events/constants';

export const StatusCard = ({
  name,
  label,
  count = 0,
  amount = 0,
  status = EventStatus.ACTIVE,
  setStatus,
  roundLeft,
  roundRight,
  arrow,
}) => {
  const theme = useTheme();
  const styles = getEventsStyles(theme);
  const [hoverState, setHoverState] = useState(false);
  const [backgroundColor, setBackgroundColor] = useState();

  const active = name === status;

  useEffect(() => {
    let color = 'white';
    if (active && label === EventStatus.ACTIVE) {
      color = PVNavy;
    } else if (active) {
      color = EventStatusColors[snakeCase(label)] || PVGray;
    } else if (hoverState) {
      color = PVHoverNavy;
    }
    setBackgroundColor(color);
  }, [active, hoverState, label]);

  const canShowEventsSummaryAmounts = true;

  const radius = theme.shape.borderRadius * 2;

  const getPillTextColor = (label) => {
    if (label === EventStatus.COMPLETED) {
      return theme.palette.common.white;
    } else {
      return theme.palette.text.primary;
    }
  };

  const pillColor = getPillTextColor(label);

  const getLabelColor = (label) => {
    return active &&
      (label === EventStatus.COMPLETED || label === EventStatus.ACTIVE)
      ? theme.palette.common.white
      : theme.palette.text.primary;
  };

  const getAmountColor = (label) => {
    return active &&
      (label === EventStatus.COMPLETED || label === EventStatus.ACTIVE)
      ? theme.palette.common.white
      : theme.palette.primary.main;
  };

  return (
    <div
      onMouseEnter={() => setHoverState(true)}
      onMouseLeave={() => setHoverState(false)}
      style={{
        ...styles.statusCard,
        marginRight: label === EventStatus.ACTIVE ? 16 : 0,
      }}
      className={`status-card-${snakeCase(name || label)}`}
      onClick={() => setStatus(name)}
    >
      <div
        style={{
          ...styles.statusBox,
          ...((label === EventStatus.ACTIVE || label === EventStatus.LEAD) ? styles.roundedLeftStatusBox : {}),
          borderRight: arrow ? 'none' : undefined,
          borderTopLeftRadius: roundLeft ? radius : undefined,
          borderBottomLeftRadius: roundLeft ? radius : undefined,
          borderTopRightRadius: roundRight * 2 ? radius : undefined,
          borderBottomRightRadius: roundRight * 2 ? radius : undefined,
          backgroundColor: backgroundColor,
        }}
      >
        <div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
            }}
          >
            <div
              style={{
                marginRight: 6,
              }}
            >
              <Typography
                variant="h5"
                sx={{
                  ...styles.statusPill,
                  fontSize: 14,
                  backgroundColor: active
                    ? theme.palette.common.white
                    : EventStatusColors[snakeCase(label)] || PVGray,
                  color: active ? theme.palette.primary.main : pillColor,
                }}
              >
                {count}
              </Typography>
            </div>
            <div>
              <Typography
                variant="h5"
                sx={{
                  ...(active ? styles.activeText : {}),
                  fontSize: 14,
                  fontWeight: 500,
                  color: getLabelColor(label),
                }}
              >
                {label}
              </Typography>
            </div>
          </div>

          {canShowEventsSummaryAmounts && (
            <div
              style={{
                marginTop: 2,
              }}
            >
              <Typography
                variant="h4"
                align="left"
                sx={{
                  ...(!active ? styles.statusCardLabel : {}),
                  ...(active ? styles.activeText : {}),
                  fontSize: 22,
                  color: getAmountColor(label),
                }}
              >
                {amount
                  ? replace(moneyPrint(round(amount / 100)), /\.\d\d/, '')
                  : '$0'}
              </Typography>
            </div>
          )}
        </div>
      </div>
      {arrow && (
        <div
          style={{
            ...styles.arrow,
            ...(active ? styles.activeArrow : {}),
          }}
        >
          <div
            style={{
              ...styles.innerArrow,
              borderLeftColor: backgroundColor,
            }}
          />
        </div>
      )}
    </div>
  );
};
